import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { handleResponse } from '../../MainModule/common/handleResponse';
import { IKnmCanceledReason } from '../interfaces/IKnmCanceledReason';

export async function fetchKnmCanceledReasons(): Promise<IKnmCanceledReason[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-canceled-reason`;
  const mockData = apiMockSwitcher<IKnmCanceledReason[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(handleResponse)
    .then((data: IKnmCanceledReason[]) =>
      data.map(item => {
        // eslint-disable-next-line no-param-reassign
        item.id = `${item.id}`;

        return item;
      }),
    );
}
